<template>
  <v-container
    id="dashboard-view"
    fluid
    tag="section"
  >
    <v-alert
      outlined
      type="info"
      dismissible
    >
      以下信息显示自己权限范围内的报表数据
    </v-alert>
    <v-row>
      <v-col
        v-for="({ actionIcon, actionText, ...attrs }, i) in stats"
        :key="i"
        cols="12"
        md="6"
        lg="3"
      >
        <material-stat-card v-bind="attrs">
          <template #actions>
            <v-icon
              class="mr-2"
              small
              v-text="actionIcon"
            />
            <div class="text-truncate">
              {{ actionText }}
            </div>
          </template>
        </material-stat-card>
      </v-col>

      <v-col
        cols="24"
        md="12"
      >
        <material-card
          color="blue"
          full-header
        >
          <template #heading>
            <div class="pa-2 white--text">
              <div class="text-h4 font-weight-light">
                客户数据
              </div>
              <div class="text-caption">
                本年度客户池数据报表
              </div>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="desserts"
            />
          </v-card-text>
        </material-card>
      </v-col>

      <!--<v-col
        cols="24"
        md="12"
      >
        <material-card
          color="green"
          full-header
        >
          <template #heading>
            <div class="pa-2 white--text">
              <div class="text-h4 font-weight-light">
                营销数据
              </div>
              <div class="text-caption">
                本年度营销数据统计报表
              </div>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
            />
          </v-card-text>
        </material-card>
      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import axios from 'axios'
  export default {
    name: 'DashboardView',

    data: () => ({
      headers: [
        {
          text: '客户编号',
          align: 'center',
          value: 'no',
          width: '150',
        },
        { text: '分配AE', value: 'auther', width: '120' },
        { text: '概况描述', value: 'description', sortable: false, width: '150' },
        { text: '客户来源', value: 'customer_source_name', width: '120' },
        { text: '线索来源', value: 'source_name', width: '120' },
        { text: '联系人', value: 'name', sortable: false, width: '100' },
        // { text: '电话', value: 'phone', sortable: false, width: '120' },
        // { text: '其他联系方式', value: 'other_phone', width: '160' },
        { text: '公司名称', value: 'company', sortable: false, width: '150' },
        { text: '搜索词', value: 'search_keyword', width: '120' },
        { text: '关键词', value: 'keyword', width: '120' },
        { text: '结果', value: 'status', width: '100' },
        // { text: '初步判断', value: 'type', width: '120' },
        // { text: '无效原因', value: 'remarks', sortable: false, width: '150' },
        // { text: '操作', value: 'actions', sortable: false, width: '100' },
      ],
      desserts: [],
      items: [],
      classifyArr: [],
      stats: [
        {
          actionIcon: 'mdi-tag',
          actionText: '年度推广客户数量',
          color: 'info',
          icon: 'mdi-account-multiple-outline',
          title: '客户数量',
          value: '0',
        },
        {
          actionIcon: 'mdi-history',
          actionText: '待定客户数量',
          color: '#FD9A13',
          icon: 'mdi-account-search',
          title: '待定客户',
          value: '0',
        },
        {
          actionIcon: 'mdi-alarm-check',
          actionText: '有效约见、报价后高意愿、报价后低意愿、谎称要签、输单、签约',
          color: 'success',
          icon: 'mdi-account-plus',
          title: '有效客户',
          value: '0',
        },
        {
          actionIcon: 'mdi-alarm-off',
          actionText: '无效客户数量',
          color: 'primary',
          icon: 'mdi-account-remove',
          title: '无效客户',
          value: '0',
        },
      ],
    }),

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取销售列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/customer/admins')
          .then(response => {
            if (response.status === 200) {
              this.items = response.data.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取lib
        axios
          .get(process.env.VUE_APP_BASE_API + '/classify/all')
          .then(response => {
            if (response.data.code === 20000) {
              this.classifyArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取工作
        axios
          .get(process.env.VUE_APP_BASE_API + '/statistics/mywork')
          .then(response => {
            if (response.data.code === 20000) {
              // console.log(response.data.data)
              this.stats[0].value = response.data.data.dataList1.toString()
              this.stats[1].value = response.data.data.dataList2.toString()
              this.stats[2].value = response.data.data.dataList3.toString()
              this.stats[3].value = response.data.data.dataList4.toString()
              this.desserts = response.data.data.data.data
              this.desserts.map((item, i, arr) => {
                switch (item.status) {
                  case 29:
                    item.status = '客户池'
                    break
                  case 30:
                    item.status = '待定'
                    break
                  case 31:
                    item.status = '有效约见'
                    break
                  case 32:
                    item.status = '报价后高意愿'
                    break
                  case 33:
                    item.status = '报价后低意愿'
                    break
                  case 36:
                    item.status = '签约'
                    break
                  case 34:
                    item.status = '谎称要签'
                    break
                  case 35:
                    item.status = '输单'
                    break
                  case 37:
                    item.status = '无效'
                    break
                }
                item.customer_source_name = this.classifyArr[item.customer_source]
                item.source_name = this.classifyArr[item.source]
              })
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  }
</script>
